export type GalleryGestureAction = "previous" | "next" | "close" | null;
export type GallerySlidePosition = "previous" | "active" | "next";

export interface GallerySlideDescriptor {
  index: number;
  key: string;
  position: GallerySlidePosition;
}

interface GalleryGestureInput {
  deltaX: number;
  deltaY: number;
  zoomScale: number;
  wasMultiTouch: boolean;
  allowTapClose: boolean;
}

export function resolveGalleryGesture({ deltaX, deltaY, zoomScale, wasMultiTouch, allowTapClose }: GalleryGestureInput): GalleryGestureAction {
  const horizontalDistance = Math.abs(deltaX);
  const verticalDistance = Math.abs(deltaY);
  if (wasMultiTouch) return null;
  if (allowTapClose && horizontalDistance <= 8 && verticalDistance <= 8) return "close";
  if (zoomScale !== 1) return null;
  if (horizontalDistance > 56 && horizontalDistance > verticalDistance * 1.2) {
    return deltaX > 0 ? "previous" : "next";
  }
  return null;
}

export function getGallerySlides(activeStep: number, total: number): GallerySlideDescriptor[] {
  if (total <= 0) return [];
  const indexAt = (step: number) => ((step % total) + total) % total;
  const active = indexAt(activeStep);
  if (total === 1) return [{ index: active, key: `gallery-step-${activeStep}`, position: "active" }];

  return [
    { index: indexAt(activeStep - 1), key: `gallery-step-${activeStep - 1}`, position: "previous" },
    { index: active, key: `gallery-step-${activeStep}`, position: "active" },
    { index: indexAt(activeStep + 1), key: `gallery-step-${activeStep + 1}`, position: "next" }
  ];
}
